import React from 'react';
import Chart from './Chart'
import KeyIndicatorsTables from './KeyIndicatorsTables';




export default function KeyIndicators() {


	return (
		<>
			<Chart></Chart>
			<KeyIndicatorsTables></KeyIndicatorsTables>
		</>
	);
}
